import React from 'react';
import { NavigateLegacy as Navigate } from '@leagueplatform/routing';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { useIsAboutMeEnabled } from '#hooks/use-is-about-me-enabled.ts';

// Pages
import { AchievementsLandingPage } from './pages/achievements-landing-page/achievements-landing-page.page';

export const AchievementsRoutes = () => {
  const { isAboutMeEnabled } = useIsAboutMeEnabled();

  return isAboutMeEnabled ? (
    // `/about-me?view=achievements` replaces the `/achievements` page when the about me module is enabled.
    <Navigate
      to={`${getModulePath(LEAGUE_MODULE_NAMES.aboutMe)}?view=achievements`}
      key="achievements"
      replace
    />
  ) : (
    <AchievementsLandingPage />
  );
};
